import { createSlice } from '@reduxjs/toolkit'

const initialState = 
    {
        user: null,
        response: null,
        loading: false,
        error: null,
        callTimes: 0,
        message: '',
        data: []
    }

export const contactUsSlice = createSlice({
    name: 'contactUs',
    initialState,
    reducers: {
        getDashboardData: (state) => {
            state.loading = true;
        },
        getContactUs: (state) => {
            state.loading = true;
        },
        removeContactUs: (state) => {
            state.loading = true;
        },
        updateContactUs: (state, action) => {
            state.value += action.payload
        },
        successContactUs: (state, action) => {
            state.data = action.payload;
            state.loading = false;
            state.error = null;
        },
        failedContactUs: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
})

// Action creators are generated for each case reducer function
export const { getContactUs, removeContactUs, updateContactUs, successContactUs, failedContactUs, getDashboardData } = contactUsSlice.actions

export default contactUsSlice.reducer